import {Box, Fab, Paper} from '@mui/material';
import {useState} from 'react';
import EnterPlayerEmailStep from './EnterPlayerEmailStep';
import {Home} from '@mui/icons-material';
import AcceptWaiverStep from './AcceptWaiverStep';
import SelectLanguageStep from './SelectLanguageStep';
import EnterPlayerDisplayNameStep from './EnterPlayerDisplayNameStep';
import ReviewDataPageStep from './ReviewDataPageStep';
import ConfirmDoneStep from './ConfirmDoneStep';
import PropTypes from 'prop-types';

export default function PlayerWorkflow({setLanguage}) {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    email: '',
    wantsNewslettersEmails: false,
    language: '',
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    gender: '',
    waiverAccepted: false,
    displayName: '',
  });

  const nextStep = () => {
    setStep(step + 1);
  };

  const prevStep = () => {
    setStep(step - 1);
  };

  const handleInputData = (values) => {
    setFormData((prevState) => ({
      ...prevState,
      ...values,
    }));
  };

  const resetFormDataAndGoToFirstStep = () => {
    setFormData({
      email: '',
      wantsNewslettersEmails: false,
      language: '',
      firstName: '',
      lastName: '',
      dateOfBirth: '',
      gender: '',
      waiverAccepted: false,
      displayName: '',
    });
    setStep(1);
  };

  let currentStepComponent;
  switch (step) {
  default:
    currentStepComponent = (<h1>Unknown Step</h1>);
    break;
  case 1:
    currentStepComponent = (
      <SelectLanguageStep
        setLanguage={setLanguage}
        nextStep={nextStep}
        handleChange={handleInputData}/>);
    break;
  case 2:
    currentStepComponent = (
      <EnterPlayerEmailStep
        nextStep={nextStep}
        handleChange={handleInputData}
        workFlowData={formData}
      />
    );
    break;
  case 3:
    currentStepComponent = (<AcceptWaiverStep
      nextStep={nextStep}
      previousStep={prevStep}
      handleChange={handleInputData}
      workFlowData={formData}
    />);
    break;
  case 4:
    currentStepComponent = (<EnterPlayerDisplayNameStep
      nextStep={nextStep}
      previousStep={prevStep}
      handleChange={handleInputData}
      workFlowData={formData}
    />);
    break;
  case 5:
    currentStepComponent = (<ReviewDataPageStep
      nextStep={nextStep}
      previousStep={prevStep}
      workFlowData={formData}
    />);
    break;
  case 6:
    currentStepComponent = (<ConfirmDoneStep
      resetFormDataAndGoToFirstStep={resetFormDataAndGoToFirstStep}
    />);
  }

  return (
    <Box sx={{display: 'flex', justifyContent: 'center'}}>
      <Box sx={{mt: 1, mb: 1}}>
        <Paper sx={{
          py: {xs: 4, md: 8}, px: {xs: 3, md: 6},
          minWidth: {xs: '80vw', md: '60vw', lg: '40vw'},
          maxWidth: {xs: '90vw', md: '70vw', lg: '50vw'},
        }}>
          {currentStepComponent}
        </Paper>
      </Box>
      <Fab color="primary"
           aria-label="add"
           onClick={resetFormDataAndGoToFirstStep}
           sx={{
             margin: 0,
             top: 'auto',
             right: 20,
             bottom: 20,
             left: 'auto',
             position: 'fixed',
           }}
      >
        <Home/>
      </Fab>
    </Box>
  );
}
PlayerWorkflow.propTypes = {
  setLanguage: PropTypes.func.isRequired,
};
